module.exports = __webpack_public_path__ + "static/media/d528eeb2-61fa-4056-b015-cb6522f3a57e.7a4d3f27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/competence/d528eeb2-61fa-4056-b015-cb6522f3a57e.png
// module id = 1474
// module chunks = 0